import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/carApplications/bus_task/page',
    method: 'post',
    data,
  })
}

export async function approval(data) {
    return request({
      url: '/v2/carApplications/bus_task/check',
      method: 'post',
      data,
    })
}